import { ref, provide, computed, watch, watchEffect } from '@vue/composition-api'
import { cloneDeep } from 'lodash-es'
import { TABLE_SETTINGS, COLUMN_SELECTION, COLUMN_INDEX } from '../_data'
import { uuidv5 } from '@/util/util'
const base = {
  align: true,
  border: false,
  size: true,
  fullScreen: true,
  columns: true,
  showIndex: false,
  showSelect: false
}
export const useColumns = (props) => {
  const columns = props.columns
  const settings = props.settings
  const tableSettings = [...TABLE_SETTINGS]
  const formatColumns = (col = []) => {
    if (!col.length) {
      return []
    }
    const list = col.map((item) => {
      let status = false
      if (typeof item.hide === 'undefined' || !item.hide) {
        status = true
      }
      return {
        ...item,
        id: uuidv5(),
        checked: typeof item.checked === 'undefined' ? status : item.checked,
        contentAlign: item.contentAlign || ''
      }
    })
    if (settings.value.showIndex) {
      const isString = typeof settings.value.showIndex === 'string'
      if (isString) {
        COLUMN_INDEX.label = settings.value.showIndex
      }
      list.splice(0, 0, COLUMN_INDEX)
    }
    if (settings.value.showSelect || props.selectable.value) {
      const others = {
        reserveSelection: props.reserveSelection.value
      }
      if (props.selectable.value) {
        others.selectable = props.selectable.value
      }
      list.splice(0, 0, Object.assign({}, COLUMN_SELECTION, others))
    }

    return list
  }
  const data = formatColumns(columns.value || [])
  const localColumns = ref(cloneDeep(data))
  let originColumns = cloneDeep(data)
  const allColumns = ref(cloneDeep(localColumns.value || []).filter((item) => !item.forceHide))
  // 表格对齐方式
  const tableAlign = ref('')
  const setTableAlign = (align) => {
    localColumns.value = localColumns.value.map((item) => ({
      ...item,
      align
    }))
    tableAlign.value = align
  }
  const renderColumns = computed(() => {
    return allColumns.value
      .filter((item) => item.checked)
      .map((item) => ({ ...item, align: item.align || tableAlign.value }))
  })
  const columnsSettings = ref([])
  const initSettings = () => {
    const settings = props.settings
    if (typeof settings.value === 'boolean' && !settings.value) {
      return []
    }
    const fromSettings = Object.assign({}, base, settings.value)
    const list = tableSettings.map((item) => {
      const fromValue = fromSettings[item.value]
      return {
        ...item,
        show: fromValue === undefined ? false : fromValue
      }
    })
    columnsSettings.value = list
  }
  const resetSettings = () => {
    const fromSettings = base
    const list = tableSettings.map((item) => {
      const fromValue = fromSettings[item.value]
      return {
        ...item,
        show: fromValue === undefined ? false : fromValue
      }
    })
    columnsSettings.value = list
  }

  const setColumns = (list, isFirst) => {
    let formatList = list
    if (isFirst) {
      formatList = formatColumns(list)
    }
    localColumns.value = [...formatList]
    if (isFirst) {
      originColumns = cloneDeep(formatList)
    }
  }
  const resetColumns = () => {
    localColumns.value = originColumns.map((item) => ({ ...item, id: uuidv5() }))
  }
  watch(localColumns, (v) => {
    allColumns.value = v.filter((item) => !item.forceHide)
  })

  watchEffect(initSettings)
  const all = {
    localColumns,
    allColumns,
    renderColumns,
    resetColumns,
    setColumns,
    settings: props.settings,
    columnsSettings,
    setTableAlign,
    tableAlign,
    resetSettings
  }
  provide('columnsInfo', {
    resetColumns,
    setColumns,
    setTableAlign,
    resetSettings
  })

  return all
}
